module.exports = __webpack_public_path__ + "static/media/twitterbw.47338bf9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/blocks/socialButtons/static/img/social/twitterbw.svg
// module id = 2070
// module chunks = 118